import styled from 'styled-components';
import MenuIconMDI from 'mdi-react/MenuIcon';
import { media, remCalc } from '@prisjakt/ui-base';

export const MenuButton = styled.button.attrs({ type: 'button' })`
  color: ${props => props.theme.header.fg};
  line-height: inherit;
  text-align: left;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  display: flex;
  width: 50px;
  height: 100%;

  ${media.mediumUp`
    width: auto;
  `};

  ${media.largeUp`
    display: none;
  `};

  &.focus-visible {
    background: ${p => (p.active ? 'white' : p.theme.buttons.primary.bg)};
  }
`;

export const MenuIcon = styled(MenuIconMDI).attrs({ size: 32 })`
  min-width: ${remCalc(27)};
`;

export const MenuText = styled.div`
  display: none;
  padding: 0 ${remCalc(5)};

  ${media.mediumUp`
    display: block;
  `};
`;
